// import React from "react";
// import Header from "../Header/Header";
// import { Link } from "react-router-dom";
// import verify from "../../assets/img/verify.svg";

// const SubscriptionSuccess = () => {
//   return (
//     <div className="sidebar_mar">
//       <Header />
//       <div className="subscription-success-container">
//         <div className="success-box">
//           <img className="verify-image" src={verify} alt="" />
//           <h2 className="success-title">Subscription Successful!</h2>
//           <p className="success-message">
//             Thank you for subscribing to one of our premium plans. You now have
//             access to all the exclusive features and tools that will supercharge
//             your experience!
//           </p>

//           <h3>Premium Features Unlocked:</h3>
//           <div className="features-list">
//             <ul>
//               <li>
//                 <img src={verify} alt="" width={24} />
//                 Unlimited access to all tools
//               </li>
//               <li>
//                 <img src={verify} alt="" width={24} /> Priority customer support
//               </li>
//               <li>
//                 <img src={verify} alt="" width={24} /> Early access to new
//                 features
//               </li>
//               <li>
//                 <img src={verify} alt="" width={24} /> Enhanced analytics
//                 dashboard
//               </li>
//             </ul>
//           </div>

//           <div className="success-actions">
//             <Link to="/dashboard" className="btna btn-primarya">
//               Go to Dashboard
//             </Link>
//             <Link to="/ProfileHeader" className="btna btn-secondarya">
//               View Profile
//             </Link>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SubscriptionSuccess;

import { useEffect, useState } from "react";
import Header from "../Header/Header";
import { Link } from "react-router-dom";
import verify from "../../assets/img/verify.svg";
import axios from "axios";
import {
  ApiBaseUrl,
  subscriptionSessionVerifyApi,
} from "../../utils/Constants";
import { useDispatch } from "react-redux";
import { getProfile } from "../../redux/GetProfileSlice";

const MAX_RETRIES = 5;
const RETRY_DELAY_MS = 3000;

const SubscriptionSuccess = () => {
  const dispatch = useDispatch();
  const [status, setStatus] = useState("loading"); // 'loading' | 'success' | 'error'
  const [message, setMessage] = useState("Verifying your subscription...");
  const [retryCount, setRetryCount] = useState(0);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sessionId = params.get("session_id");

    if (!sessionId) {
      setStatus("error");
      setMessage("Invalid session. Please contact support.");
      return;
    }

    verifySession(sessionId, 0);
  }, []);

  const verifySession = async (sessionId, attempt) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${ApiBaseUrl}${subscriptionSessionVerifyApi}?session_id=${sessionId}`,
        { headers: { Authorization: token } },
      );

      const { status: apiStatus, message: apiMessage } = response.data;

      if (apiStatus === 1) {
        // ✅ Success — subscription is active
        setStatus("success");
        setMessage(apiMessage || "Subscription activated successfully!");
      } else if (apiStatus === 2) {
        // ⏳ Webhook still processing — retry
        if (attempt < MAX_RETRIES) {
          setRetryCount(attempt + 1);
          setMessage(
            `Processing your subscription... (${attempt + 1}/${MAX_RETRIES})`,
          );
          setTimeout(
            () => verifySession(sessionId, attempt + 1),
            RETRY_DELAY_MS,
          );
        } else {
          // Max retries hit — show success anyway, webhook will finish in background
          setStatus("success");
          setMessage(
            "Your payment was received! Subscription will be active shortly.",
          );
        }
      } else {
        // ❌ Error
        setStatus("error");
        setMessage(
          apiMessage ||
            "Failed to verify subscription. Please contact support.",
        );
      }
      dispatch(getProfile());
    } catch (error) {
      console.error("verifySession error:", error);
      if (attempt < MAX_RETRIES) {
        setRetryCount(attempt + 1);
        setTimeout(() => verifySession(sessionId, attempt + 1), RETRY_DELAY_MS);
      } else {
        setStatus("error");
        setMessage(
          "Something went wrong. Please contact support if your subscription is not active.",
        );
      }
    }
  };

  // ── Loading State ─────────────────────────────────────────────────────────
  if (status === "loading") {
    return (
      <div className="sidebar_mar">
        <Header />
        <div className="subscription-success-container">
          <div
            className="success-box"
            style={{ textAlign: "center", padding: "60px 20px" }}
          >
            <div className="spinner" style={spinnerStyle} />
            <h2 className="success-title" style={{ marginTop: 24 }}>
              Verifying Payment...
            </h2>
            <p className="success-message">{message}</p>
            {retryCount > 0 && (
              <p style={{ color: "#888", fontSize: 13 }}>
                Retry attempt {retryCount} of {MAX_RETRIES}
              </p>
            )}
          </div>
        </div>
      </div>
    );
  }

  // ── Error State ───────────────────────────────────────────────────────────
  if (status === "error") {
    return (
      <div className="sidebar_mar">
        <Header />
        <div className="subscription-success-container">
          <div
            className="success-box"
            style={{ textAlign: "center", padding: "60px 20px" }}
          >
            <h2 className="success-title" style={{ color: "#e53935" }}>
              Verification Failed
            </h2>
            <p className="success-message">{message}</p>
            <div className="success-actions">
              <Link to="/subscription-plans" className="btna btn-primarya">
                Back to Plans
              </Link>
              <Link to="/dashboard" className="btna btn-secondarya">
                Go to Dashboard
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // ── Success State ─────────────────────────────────────────────────────────
  return (
    <div className="sidebar_mar">
      <Header />
      <div className="subscription-success-container">
        <div className="success-box">
          <img className="verify-image" src={verify} alt="" />
          <h2 className="success-title">Subscription Successful!</h2>
          <p className="success-message">
            Thank you for subscribing to one of our premium plans. You now have
            access to all the exclusive features and tools that will supercharge
            your experience!
          </p>

          <h3>Premium Features Unlocked:</h3>
          <div className="features-list">
            <ul>
              <li>
                <img src={verify} alt="" width={24} />
                Unlimited access to all tools
              </li>
              <li>
                <img src={verify} alt="" width={24} /> Priority customer support
              </li>
              <li>
                <img src={verify} alt="" width={24} /> Early access to new
                features
              </li>
              <li>
                <img src={verify} alt="" width={24} /> Enhanced analytics
                dashboard
              </li>
            </ul>
          </div>

          <div className="success-actions">
            <Link to="/dashboard" className="btna btn-primarya">
              Go to Dashboard
            </Link>
            <Link to="/ProfileHeader" className="btna btn-secondarya">
              View Profile
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

const spinnerStyle = {
  width: 48,
  height: 48,
  border: "5px solid #f0f0f0",
  borderTop: "5px solid #4f46e5",
  borderRadius: "50%",
  animation: "spin 1s linear infinite",
  margin: "0 auto",
};

// Inject spin keyframe once
if (typeof document !== "undefined" && !document.getElementById("spin-style")) {
  const style = document.createElement("style");
  style.id = "spin-style";
  style.innerHTML = "@keyframes spin { to { transform: rotate(360deg); } }";
  document.head.appendChild(style);
}

export default SubscriptionSuccess;
